























import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import DpDiagram from '@/components/atoms/DpDiagram/index.vue';

const moment = require('moment');

@Component({
  name: 'PerformanceTrendDiagram',
  components: {},
})
export default class PerformanceTrendDiagram extends DpDiagram {
  @Prop() protected values!: any;

  @Prop() protected unit!: any;

  @Prop({ default: false }) protected unitAfterValue!: boolean;

  @Prop({ default: 'MMM D, YYYY' }) protected dateFormat!: string;

  @Prop() protected types!: any;

  @Prop() protected typeTitles!: any;

  @Prop() protected curveStyles!: any;

  @Prop() protected hasMinPrice!: any;

  @Prop() protected hasMaxPrice!: any;

  @Prop() protected selectedDate!: any;

  @Prop({ default: 3 }) protected hoverWidth!: any;

  @Prop({ default: true }) protected withPopup!: boolean;

  @Prop({ default: true }) protected withXAxis!: boolean;

  @Prop({ default: () => [] }) protected excludeMarkersTypes!: any;

  protected isSmallWidth = (width: number) => width < 600;

  protected detailPopup: any = {};

  protected generateChart(d3: any, width: number, height: number) {
    let bottom = this.isSmallWidth(width) ? 60 : 30;
    if (!this.withXAxis) {
      bottom = 0;
    }
    const margin = ({
      top: 25, right: 40, bottom, left: 20,
    });
    return this.createChart({
      d3,
      width,
      height,
      data: this.values,
      margin,
      unit: this.unit,
      types: this.types,
      typeTitles: this.typeTitles,
      curveStyles: this.curveStyles,
      hoverWidth: this.hoverWidth,
      withXAxis: this.withXAxis,
      selectedDate: this.selectedDate,
      dateFormat: this.dateFormat,
      excludeMarkersTypes: this.excludeMarkersTypes,
    });
  }

  protected createChart = ({
    d3,
    width,
    height,
    data,
    margin,
    unit,
    types,
    typeTitles,
    curveStyles,
    hoverWidth,
    withXAxis,
    selectedDate,
    dateFormat,
    excludeMarkersTypes,
  }: any) => {
    const that: any = this;

    const dataDates: any = data.map((item: any) => ({
      date: new Date(item.name),
      name: item.name,
    }));

    const isSmallWidth = this.isSmallWidth(width);

    const activeTypesFunc: any = (items: any) => Object.keys(items).filter((type: any) => items[type]);

    const activeTypes: any = activeTypesFunc(types);
    const activeTypesOnlyCurves: any = activeTypes.filter((type: any) => curveStyles[type].type !== 'line');

    const maxValue: any = d3.max(data, (d: any) => {
      const values: any = activeTypes.map((type: any) => {
        if (curveStyles[type].type !== 'line') {
          return d[String(type)] || 0;
        }
        return curveStyles[type].value;
      });
      return Math.max(...values);
    });

    const startDate = new Date(data[0].name);
    const endDate = new Date(data[data.length - 1].name);
    const x = (d3 as any).scaleTime()
      .domain([startDate, endDate])
      .range([margin.left, width - margin.right]);
    const y = (d3 as any).scaleLinear()
      .domain([0, maxValue])
      // .nice()
      .range([height - margin.bottom, margin.top]);

    const addHorizontalLine = (svg: any, value: any, text: any, colorStroke: any, colorLabel: any, lineType: string) => {
      const rectContainer: any = svg.append('g');
      const line = rectContainer.append('line');
      line
        .attr('x1', 0)
        .attr('y1', y(value))
        .attr('x2', width - margin.top - 23)
        .attr('y2', y(value))
        .attr('stroke', colorStroke);
      if (lineType === 'dashed') {
        line.attr('stroke-dasharray', '5, 5');
      }
      if (lineType === 'dotted') {
        line.attr('stroke-dasharray', '2, 2');
      }

      const label: any = rectContainer
        .append('g')
        .attr('transform', `translate(${width - margin.top - 17}, ${y(value) - 9})`);
      label.append('path')
        .attr('d', 'M7.56386 0.590841L1.20027 7C0.391402 7.81466 0.432844 9.14154 1.29098 9.90414L7.58221 15.495C7.94829 15.8203 8.42101 16 8.91076 16H31.9966C33.1012 16 33.9966 15.1046 33.9966 14V2C33.9966 0.895431 33.1012 0 31.9966 0H8.98311C8.4502 0 7.93933 0.212678 7.56386 0.590841Z')
        .attr('fill', colorLabel);
      label.append('text')
        .attr('y', 11)
        .attr('x', 31)
        .attr('fill', '#FCFCFC')
        .style('font-size', '10px')
        .style('font-style', 'normal')
        .style('line-height', '14px')
        .style('font-family', 'IBM Plex Sans Mono')
        .attr('text-anchor', 'end')
        .style('letter-spacing', '0.05em')
        .text(text);
      return rectContainer;
    };

    const addMin: any = (svg: any, value: any) => addHorizontalLine(svg, value, 'MIN', '#E1315A', '#E1315A', 'solid');

    const addMax: any = (svg: any, value: any) => addHorizontalLine(svg, value, 'MAX', '#24BA45', '#24BA45', 'solid');

    const addUnitLabel: any = (svg: any) => {
      svg
        .append('text')
        .attr('x', width - margin.right + 12)
        .attr('y', height - margin.bottom + 17.5)
        .attr('fill', '#596D79')
        .style('font-size', '10px')
        .style('font-style', 'normal')
        .style('line-height', '16px')
        .style('font-family', 'IBM Plex Sans')
        .style('letter-spacing', '0.05em')
        .text(unit);
    };

    const addCurve: any = (svg: any, type: string) => {
      const dataPrepared: any = data.map((item: any) => ({
        date: new Date(item.name),
        name: item.name,
        value: item[type],
      }))
        .filter((item: any) => item.value !== null && item.value !== undefined);
      const pathContainer: any = svg.append('g');
      const path: any = pathContainer.append('path')
        .datum(dataPrepared)
        .attr('fill', curveStyles[type].fill ? curveStyles[type].fill : 'none')
        .attr('fill-opacity', curveStyles[type].fillOpacity ? curveStyles[type].fillOpacity : 1)
        .attr('stroke', curveStyles[type].color)
        .attr('stroke-width', 1)
        .attr('d', curveStyles[type].fill
          ? (d3 as any).area()
            .curve(d3[curveStyles[type].curveType])
            .x((d: any) => x(d.date))
            .y0(height - margin.bottom)
            .y1((d: any) => y(d.value))
          : (d3 as any).line()
            .curve(d3[curveStyles[type].curveType])
            .x((d: any) => x(d.date))
            .y((d: any) => y(d.value)));
      if (curveStyles[type].style === 'dashed') {
        path.style('stroke-dasharray', ('3, 3'));
      }
      if (curveStyles[type].curveType === 'curveLinear') {
        pathContainer.append('g')
          .selectAll('g')
          .data(dataPrepared)
          .join('circle')
          .attr('cx', (d: any) => x(d.date))
          .attr('cy', (d: any) => y(d.value))
          .attr('r', 3)
          .attr('fill', curveStyles[type].color);
      }
      return pathContainer;
    };

    const addCurveMarkers: any = (svg: any, type: string) => {
      const dataPrepared: any = data.map((item: any) => ({
        date: new Date(item.name),
        name: item.name,
        value: item[type],
      }))
        .filter((item: any) => item.value);
      const pathContainer: any = svg.append('g');
      pathContainer
        .selectAll('g')
        .data(dataPrepared)
        // eslint-disable-next-line
        .join(function(group: any) {
          const container = group.append('g');
          container.append('circle')
            .attr('class', (d: any) => `marker2-${d.name}`)
            .attr('cx', (d: any) => x(d.date))
            .attr('cy', (d: any) => y(d.value))
            .attr('r', 6)
            .attr('fill', curveStyles[type].color)
            .attr('opacity', 0);
          container.append('circle')
            .attr('class', (d: any) => `marker-${d.name}`)
            .attr('cx', (d: any) => x(d.date))
            .attr('cy', (d: any) => y(d.value))
            .attr('r', 3)
            .attr('fill', curveStyles[type].color)
            .attr('opacity', 0);
        });
    };

    const addGrid: any = (svg: any) => {
      svg.append('g')
        .selectAll('g')
        .data(dataDates)
        // eslint-disable-next-line
        .join(function (group: any) {
          const container = group.append('g');
          container.append('rect')
            .attr('x', (d: any) => x(d.date) - 0.5)
            .attr('y', -margin.bottom)
            .attr('height', height)
            .attr('fill', '#F0F0F0')
            .attr('opacity', (d: any) => {
              const dateMoment: any = moment(d.date);
              return Number(Number(dateMoment.format('D')) === 1
                && [3, 6, 9, 12].indexOf(Number(dateMoment.format('M'))) !== -1);
            })
            .attr('width', 1);
        });
      svg.append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', width - margin.right)
        .attr('height', 1)
        .attr('fill', '#F0F0F0');
    };

    const yscale = (d3 as any)
      .scaleLinear()
      .domain([0, maxValue])
      .range([height - margin.bottom, margin.top]);

    const svg: any = (d3 as any).create('svg')
      .attr('height', height)
      .attr('width', width)
      .attr('viewBox', [0, 0, width, height]);

    const yAxis = (g: any) => {
      g
        .attr('transform', `translate(${width - margin.right + 10},0)`)
        .call((d3 as any)
          .axisRight(y)
          .scale(yscale)
          .ticks(5, 'f')
          .tickSizeInner(20)
          .tickSizeOuter(0));
      g.select('.domain').remove();
      g.selectAll('.tick')
      // eslint-disable-next-line
        .each(function (d: any, i: any) {
          const tick: any = (d3 as any).select(this);
          if (i === 0) {
            tick.style('opacity', 0);
          }
          svg.append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('transform', tick.attr('transform'))
            .attr('width', width - margin.right)
            .attr('height', 1)
            .attr('fill', '#F0F0F0');
          tick.select('line')
            .attr('stroke-width', 0.5)
            .attr('stroke', '#E5E5E5');
          tick
            .select('text')
            .attr('y', 8)
            .attr('x', 0)
            .attr('fill', '#283237')
            .style('font-weight', 400)
            .style('font-size', '9px')
            .style('font-style', 'normal')
            .style('line-height', '24px')
            .style('font-family', 'IBM Plex Sans');
        });
    };


    svg.append('g')
      .call(yAxis);

    const xAxis = (g1: any) => {
      g1
        .attr('transform', `translate(0,${height - margin.bottom})`)
        .call((d3 as any)
          .axisBottom(x)
          .tickFormat((date: any, index: number) => {
            if (d3.timeYear(date) < date && index !== 0) {
              return d3.timeFormat('%b')(date);
            }
            return d3.timeFormat('%b %Y')(date);
          })
          .tickSizeInner(5)
          .tickSizeOuter(0)
          .tickPadding(10));

      g1.select('.domain').attr('stroke', '#E5E5E5');
      g1.selectAll('.tick')
      // eslint-disable-next-line
        .each(function (d: any) {
          const tick: any = (d3 as any).select(this);
          const textValue = tick.select('text').text();
          let year: any;
          let month: any;
          if (isSmallWidth) {
            [month, year] = textValue.split(' ');
            if (year) {
              tick.select('text').text(month);
            }
          }
          tick
            .select('text')
            .style('font-size', '10px')
            .style('font-style', 'normal')
            .style('line-height', '16px')
            .style('font-family', 'IBM Plex Sans')
            .style('letter-spacing', '0.05em')
            .style('text-transform', 'uppercase')
            .attr('fill', '#283237');
          if (year) {
            tick
              .append('text')
              .style('font-size', '10px')
              .style('font-style', 'normal')
              .style('line-height', '16px')
              .style('font-family', 'IBM Plex Sans')
              .style('letter-spacing', '0.05em')
              .attr('transform', 'translate(0, 40)')
              .attr('fill', '#283237')
              .text(`'${year.slice(-2)}`);
          }
          (d3 as any)
            .select(this)
            .select('line')
            .attr('stroke', '#C8CAD0');
        });
    };

    if (withXAxis) {
      svg.append('g')
        .call(xAxis);
    }

    const curves: any = [];
    activeTypes.forEach((type: any) => {
      if (types[type]) {
        if (['minimumPrice', 'maximumPrice'].indexOf(type) !== -1) {
          return;
        }
        if (curveStyles[type].type === 'line') {
          const curveStyle: any = curveStyles[type];
          const horizontalLine: any = addHorizontalLine(
            svg,
            curveStyle.value,
            `${curveStyles[type].sign ? curveStyles[type].sign : ''}${curveStyle.value}${curveStyles[type].unit ? curveStyles[type].unit : ''}`,
            curveStyle.color,
            curveStyle.color,
            curveStyle.style,
          );
          curves.push(horizontalLine);
        } else {
          curves.push(addCurve(svg, type));
        }
      }
    });

    addGrid(svg);

    svg.append('g')
      .selectAll('g')
      .data(dataDates)
      // eslint-disable-next-line
      .join(function (group: any) {
        group.append('g')
          .append('rect')
          .attr('class', (d: any) => `vertical-line-${d.name}`)
          .attr('opacity', 0)
          .attr('x', (d: any) => x(d.date))
          .attr('y', -margin.bottom)
          .attr('height', height)
          .attr('fill', '#596D79')
          .attr('width', 1);
      });

    activeTypesOnlyCurves.forEach((type: any) => {
      if (types[type]) {
        if (['minimumPrice', 'maximumPrice', 'percentile25', 'percentile50', 'percentile75'].indexOf(type) !== -1) {
          return;
        }
        if (excludeMarkersTypes.indexOf(type) !== -1) {
          return;
        }
        addCurveMarkers(svg, type);
      }
    });

    svg.append('g')
      .selectAll('g')
      .data(dataDates)
      // eslint-disable-next-line
      .join(function (group: any) {
        const container = group.append('g');
        container.append('rect')
          .attr('class', (d: any) => `hover hover-${d.name}`)
          .attr('date', (d: any) => d.name)
          .attr('x', (d: any) => x(d.date) - Math.round(hoverWidth / 2))
          .attr('y', -margin.bottom)
          .attr('height', height)
          .attr('fill', '#fff')
          .attr('opacity', 0.01)
          .attr('width', hoverWidth);
      });

    const onSelectDate: any = (date: any) => {
      const dateFormated: string = moment(date).format(dateFormat);
      const verticalLine: any = svg.select(`.vertical-line-${date}`);
      verticalLine.attr('opacity', 1);
      svg.selectAll(`.marker-${date}`)
        .attr('opacity', 1);
      svg.selectAll(`.marker2-${date}`)
        .attr('opacity', 0.5);
      const selectedDateX: any = verticalLine.attr('x');
      const selectedDateY: any = height / 2;
      that.$set(that.detailPopup, 'show', true);
      that.$set(that.detailPopup, 'date', dateFormated);
      that.$set(that.detailPopup, 'x', selectedDateX);
      that.$set(that.detailPopup, 'y', selectedDateY);
      that.setSelectedDate(date);
      that.setSelectedDateCoord({ x: selectedDateX, y: selectedDateY });
      let labels: any = [];
      activeTypesOnlyCurves.forEach((type: any) => {
        if (types[type]) {
          if (type === 'minimumPrice' || type === 'maximumPrice') {
            return;
          }
          if (excludeMarkersTypes.indexOf(type) !== -1) {
            return;
          }
          const day: any = data.find((item: any) => (item.name === date));
          if (day && day[type] !== undefined && day[type] !== null) {
            labels.push({
              value: day[type],
              color: curveStyles[type].color,
              title: typeTitles[type],
            });
          }
        }
      });
      labels = labels.sort((a: any, b: any) => (a.value < b.value ? 1 : -1));
      that.$set(that.detailPopup, 'labels', labels);
    };

    if (selectedDate) {
      onSelectDate(selectedDate);
    }

    svg.selectAll('.hover')
    // eslint-disable-next-line
      .on('mouseenter', function () {
        const date = (d3 as any).select(this).attr('date');
        onSelectDate(date);
      })
      // eslint-disable-next-line
      .on('mouseleave', function () {
        const date = (d3 as any).select(this).attr('date');
        const verticalLine: any = svg.select(`.vertical-line-${date}`);
        verticalLine.attr('opacity', 0);
        svg.selectAll(`.marker-${date}`)
          .attr('opacity', 0);
        svg.selectAll(`.marker2-${date}`)
          .attr('opacity', 0);
        that.$set(that.detailPopup, 'show', false);
        that.setSelectedDate(null);
        that.setSelectedDateCoord({});
      });

    addUnitLabel(svg);

    if (this.hasMinPrice && types.minimumPrice) {
      const curveMin: any = addMin(svg, data[0].minimumPrice);
      curves.push(curveMin);
    }

    if (this.hasMaxPrice && types.maximumPrice) {
      const curveMax: any = addMax(svg, data[0].maximumPrice);
      curves.push(curveMax);
    }

    return svg;
  };

  @Watch('types', { deep: true })
  @Watch('values', { immediate: true, deep: true })
  @Watch('selectedDate', { deep: true })
  protected valuesChange() {
    if (this.values) {
      this.renderChart();
    }
  }

  protected setSelectedDate(item: any) {
    this.$emit('selectDate', item);
  }

  protected setSelectedDateCoord(item: any) {
    this.$emit('selectDateCoord', item);
  }
}
